// extracted by mini-css-extract-plugin
module.exports = {"container":"ConsentAndPaySection_container__m_M2W"};